import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { TargetingSettingsContext } from './targeting-settings-context';
import { TargetingScope } from './config';

export class GridView extends DeterministicWrapperView {
  viewFactory({ grid }) {
    return grid.gridView;
  }

  get className() {
    return '';
  }
}

export class BaseGridView extends DeterministicView {
  initialize({
    campaignId,
    adgroupId,
    dataSource,
    setting,
    scope,
    level,
    perfMarker,
  }) {
    super.setState({
      campaignId,
      adgroupId,
      dataSource,
      setting,
      scope,
      level,
    });

    this.initializeAsync = this.buildGrid({
      dataSource,
      scope,
      level,
      perfMarker,
    }).then(() => {
      this.checkGrid('BaseGridView.buildGrid');
      const hiddenFilter = this.grid.filterState.createFilter(this.repository.hiddenFilter);
      this.grid.filterState.setHiddenFilter(hiddenFilter);

      this.grid.gridView.on('didEdit', this.onItemModified, this);
      this.grid.gridView.on('editInherited', this.inlineEditMultiTargets, this);
      this.grid.filterState.on('filterUpdated', this.onFilterUpdated, this);
    });

    this.showTooMuchDataToDownloadError = false;
  }

  checkGrid(api) {
    if (_.isUndefined(this.grid)) {
      TargetingSettingsContext.logger.logMessage(
        'ClientTrace',
        { name: 'Info', value: 0 },
        api,
        'Grid hasnot been created.'
      );
    }
  }

  buildGrid() {
    throw new Error('Not implemented!');
  }

  inlineEditMultiTargets() {
    throw new Error('Not implemented!');
  }

  renderTrunk() {
    super.renderTrunk();
    this.initializeAsync.then(() => {
      this.checkGrid('BaseGridView.renderTrunk');
      this.$('.upper-toolbar').append(this.grid.toolbar.gridToolbarGroup.toolbarWithName('upper-toolbar').$el);
      if (this.grid.filterState.getFilterBar()) {
        this.$('.filter-bar').append(this.grid.filterState.getFilterBar().$el);
      }
    });
    return this;
  }

  onFilterUpdated() {
    if (this.grid.filterState.getFilterBar() && this.$('.filter-bar').children().length === 0) {
      this.$('.filter-bar').append(this.grid.filterState.getFilterBar().$el);
    }
  }

  onItemModified(model, item, property) {
    if (model) {
      let updated = false;
      if (property === 'BidAdjustments') {
        updated = item.CriterionBid.Multiplier !== model.BidMultiplier;
        item.CriterionBid.Multiplier = model.BidMultiplier; // eslint-disable-line no-param-reassign
      }

      if (updated) {
        this.repository.update(item)
          .catch(() => {
            window.App.views.alertCenter.showError(TargetingSettingsContext.i18n.getString('GenericErrorMessage'));
          })
          .finally(() => {
            this.grid.gridView.refresh(true);
          })
          .withUiBlock(this.$el);
      }
    }
  }

  remove() {
    if (this.grid) {
      if (this.grid.toolbar && this.grid.toolbar.gridToolbarGroup) {
        this.grid.toolbar.gridToolbarGroup.remove();
        this.grid.toolbar.gridToolbarGroup = null;
      }

      if (this.grid.inlineChart) {
        this.grid.inlineChart.remove();
        this.grid.inlineChart = null;
      }
    }
    if (this.editorView) {
      this.editorView.remove();
    }

    super.remove();
  }

  gridLoadErrorHandler(data) {
    if (_.any(data.errors, err => err.Code === 'TooMuchDataToDownload')) {
      this.showTooMuchDataToDownloadError = true;
    } else {
      window.App.views.alertCenter.showError(TargetingSettingsContext.i18n.getString('GenericErrorMessage'));
    }
  }

  getOverThresholdMessage() {
    const scope = this.model.get('scope');
    const { i18n } = TargetingSettingsContext;
    return _.result({
      [TargetingScope.Account]: i18n.getString('TargetingSettings_Grid_OverThreshold_Account'),
      [TargetingScope.Campaign]: i18n.getString('TargetingSettings_Grid_OverThreshold_Campaign'),
    }, scope);
  }

  afterFindAllCallback(options, data) {
    if (_.has(data, 'errors')) {
      this.gridLoadErrorHandler(data);
    } else {
      this.grid.gridView.deselectAll();
    }

    return data;
  }

  showEditor(view) {
    // use defer here to wait for the dropdown menu to hide first
    _.defer(() => {
      if (this.editorView) {
        this.editorView.remove();
      }
      this.editorView = view;

      const editorContainer = this.$el.find('.editor-container');
      const gridToolbar = this.$el.find('.grid-toolbar');

      editorContainer.html(this.editorView.$el);
      editorContainer.show();

      // hide the toolbar with empty view, which will have blank height
      gridToolbar.hide();
      this.grid.toolbar.gridToolbarGroup.hideAllToolbars();

      this.editorView.once('close', (response) => {
        editorContainer.hide();
        this.editorView.remove();
        this.editorView = null;

        gridToolbar.show();
        this.grid.toolbar.gridToolbarGroup.showAllToolbars();
        if (response) {
          this.grid.gridView.refresh(true);
        }
      });
      window.scrollTo(0, 0);
    });
  }
}
